import { Avatar, Card, Statistic } from 'antd'
import {
  CustomPieChart,
  FlexColumn,
  FlexRow,
  FlexRowBetween,
  UserAvatarWithName,
} from 'components'
import {
  ThumbsUp,
  MonitorPlay,
  UserCircle,
  Eye,
  ChatTeardropText,
} from 'phosphor-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { CommonUtility } from 'utility'

const CenterPart = styled.div`
  display: flex;
  justify-content: center;
`
const ViewAll = styled.h6`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: #0056b3;
  }
`
const StatContainer = styled(FlexRow)`
  display: flex;
  align-items: center;
  gap: 2px;
  background: #fff;
  padding: 8px;
  border-radius: 4px;
`

const StatText = styled.h6`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
`
const SectionBox = styled.section`
  border: 1pxsolid #f0f0f0;
  box-shadow: 6.33px 6.33px 50.94px 0px #0000000d;
  margin: 15px 0;
  height: 100%;
  border-radius: 16px;
  background: #fff;

  border: 1px solid ${({ theme }) => theme.colors.border || '#f0f0f0'};
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
  }
`
const CardContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
`
const CustomStatistic = styled(Statistic)`
  display: flex;
  flex-direction: column-reverse;
  .ant-statistic-content-value {
    font-size: 20px;
    font-weight: 600;
  }
  .ant-statistic-title {
    color: #000;
    font-size: 11px;
  }
`
export const TrandingVideosRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 0;
  background-color: #fafafa;
  border-bottom: 1px solid #eaeaea;
`

export const Thumbnail = styled.img`
  width: 50px;
  height: 50px;
  object-fit: cover;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
`

const StyledCard = styled(Card)`
  flex: 1;
  border-radius: 16px;
  background: #fff;
  box-shadow: 6.33px 6.33px 50.94px 0px #0000000d;
  .ant-card-body {
    display: flex;
    min-width: 150px;
    padding: 8px;
    gap: 10px;
    align-items: center;
    text-align: left;
  }
`

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;

  background: linear-gradient(90deg, #5a65c9 20%, #303b97 100%);

  border-radius: 50%;
  padding: 8px 16px;
`
export const CardsBox = styled.div`
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
  }
`
export const LiveRoundSections = ({ data }) => {
  return (
    <CardsBox className="p-3">
      <h4 className="mb-3">Live Competition</h4>
      <CardContainer>
        <StyledCard>
          <IconWrapper>
            <MonitorPlay size={30} color="#ffff" />
          </IconWrapper>
          <CustomStatistic
            title="Top Videos Uploaded"
            value={CommonUtility.formatNumberToSocial(data?.total_videos)}
          />
        </StyledCard>
        <StyledCard>
          <IconWrapper>
            <UserCircle size={30} color="#ffff" />
          </IconWrapper>
          <CustomStatistic
            title="Creators Participated"
            value={CommonUtility.formatNumberToSocial(data?.total_participants)}
          />
        </StyledCard>
        <StyledCard>
          <IconWrapper>
            <ThumbsUp size={24} color="#ffff" />
          </IconWrapper>
          <CustomStatistic
            title="Total Votes"
            value={CommonUtility.formatNumberToSocial(data?.total_votes)}
          />
        </StyledCard>
        <StyledCard>
          <IconWrapper>
            <Eye size={24} color="#ffff" />
          </IconWrapper>
          <CustomStatistic
            title="Total Views"
            value={CommonUtility.formatNumberToSocial(data?.total_views)}
          />
        </StyledCard>
      </CardContainer>
    </CardsBox>
  )
}
const TrendingVideoItemBox = ({ data }) => {
  return (
    <TrandingVideosRow className="align-items-center w-100 py-2 bg-white">
      <Avatar
        shape="square"
        src={data?.thumbnail_url}
        style={{
          width: '50px',
          height: '50px',
          objectFit: 'cover',
          aspectRatio: '1/1',
        }}
      />
      <FlexColumn className="col-8 ps-3">
        <h6 className="mb-1">{data?.title}</h6>
        <FlexRow className="align-items-center">
          <UserAvatarWithName
            size={50}
            id={data?.user?.fid}
            title={data?.user?.name}
            url={data?.user?.image}
          />
        </FlexRow>
      </FlexColumn>
      <FlexRowBetween className="col-3 align-items-center justify-content-end gap-3">
        <StatContainer>
          <StatText>
            {CommonUtility.numberWithCommas(data?.votes_count)}
          </StatText>
          <ThumbsUp size={20} className="my-0 ms-2" />
        </StatContainer>
        <StatContainer>
          <StatText>
            {CommonUtility.numberWithCommas(data?.comment_count)}
          </StatText>
          <ChatTeardropText size={20} className="my-0 ms-2" />
        </StatContainer>
      </FlexRowBetween>
    </TrandingVideosRow>
  )
}
export const TrendingVideosSections = ({ data }) => {
  const navigate = useNavigate()
  return (
    <SectionBox className="p-3">
      <FlexRowBetween className="mb-4 mt-4">
        <h4>Trending Videos </h4>
        <ViewAll
          onClick={() => navigate('/app/videos', { state: { for: 'popular' } })}
        >
          View All
        </ViewAll>
      </FlexRowBetween>
      {data.map(ele => (
        <div key={ele?._id} className="mb-3">
          <TrendingVideoItemBox data={ele} />
        </div>
      ))}
    </SectionBox>
  )
}
const CreatorBox = ({ item }) => {
  console.log('🚀 ~ CreatorBox ~ item:', item)
  return (
    <FlexRow>
      <FlexRowBetween className="col align-items-center">
        <FlexRow className="align-items-center">
          <UserAvatarWithName
            size={50}
            id={item?.user?.fid}
            title={item?.user?.name || 'John Dell'}
            url={item?.user?.image}
          />
        </FlexRow>
        <FlexRow className="col-4 align-items-center justify-content-end">
          <StatContainer>
            <StatText>
              {' '}
              {CommonUtility.numberWithCommas(Number(item?.total_votes || 0))}
            </StatText>
            <ThumbsUp size={24} className="my-0 ms-2" />
          </StatContainer>
        </FlexRow>
      </FlexRowBetween>
    </FlexRow>
  )
}
export const TopCreatorsSections = ({ data }) => {
  const navigate = useNavigate()
  return (
    <SectionBox className="p-3">
      <FlexRowBetween className="mb-4 mt-4">
        <h4>Top Creators </h4>
        <ViewAll onClick={() => navigate('/app/manage-creators')}>
          View All
        </ViewAll>
      </FlexRowBetween>
      {data.map(ele => (
        <div key={ele?._id} className="mb-3">
          <CreatorBox item={ele} />
        </div>
      ))}
    </SectionBox>
  )
}

export const LiveRoundLeaderboardSections = () => {
  return (
    <SectionBox className="p-3">
      <FlexRowBetween className="mb-4 mt-4">
        <h4>Live Round Leaderboard </h4>
        <ViewAll>View All</ViewAll>
      </FlexRowBetween>
      {[1, 2, 3].map(ele => (
        <div key={ele?._id} className="mb-3">
          <CreatorBox liveRound item={ele} />
        </div>
      ))}
    </SectionBox>
  )
}

// export const CreatorGenreSections = () => {
//   return (
//     <SectionBox className="p-3">
//       <FlexRowBetween className="mb-4">
//         <h4>Creators based on Genre </h4>
//       </FlexRowBetween>
//       {[1, 2, 3].map(ele => (
//         <div key={ele?._id} className="mb-3">
//           <CreatorBox liveRound item={ele} />
//         </div>
//       ))}
//     </SectionBox>
//   )
// }
export const CreatorGenreSections = ({ data }) => {
  return (
    <SectionBox className="p-3">
      <FlexRowBetween className="mb-4 mt-3">
        <h4>Creators based on Genre</h4>
      </FlexRowBetween>
      <CenterPart>
        <CustomPieChart data={data || []} />
      </CenterPart>
    </SectionBox>
  )
}
